module.exports = __webpack_public_path__ + "static/media/neos.8d99f613.svg";